"use strict";
var ApolloProvider_1 = require('./ApolloProvider');
exports.ApolloProvider = ApolloProvider_1.default;
var graphql_1 = require('./graphql');
exports.graphql = graphql_1.default;
exports.withApollo = graphql_1.withApollo;
var compose_1 = require('recompose/compose');
exports.compose = compose_1.default;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-apollo/index.js
 ** module id = 82
 ** module chunks = 0
 **/